<main>
  <div class="row register" [ngClass]="{'fly-out': registerService._isFlyout}">
    <div id="overlay" *ngIf="!dataReady" class="loading-overlay">
      <div class="loading-spinner"><img src="/content/images/loading3.gif" width="80" height="80" alt="Loading..."/></div>
    </div>
    <div class="col center">
      <form [formGroup]="aauthService.formModel2" *ngIf="aauthService.formModel2" name="frmRegister2" (submit)="onSubmit()">
        <h1>
          Membership has
          <span class="block bold">real privileges!</span>
        </h1>
        <h2>Register to enjoy everything Rankipedia offers</h2>
        <div class="type-select" *ngIf="aauthService.regModel2.memberType == 5">
          <h3>I am:</h3>
          <div class="row form-group">
            <div class="col mem-type" [ngClass]="{ selected: aauthService.regModel2.corpType == 1 }">
              <input type="radio" name="corpType" #individualType id="individualType" value="1" checked (change)="radioChangeHandler($event)" class="form-control" formControlName="corpType"/>
              <label for="individualType" id="lbRegisterIndividual">an Individual</label>
              <p>
                You are a professional and your work is known by your personal
                name, such as lab technicians, actors, musicians, artists and
                more.
              </p>
            </div>
            <div class="col mem-type" [ngClass]="{ selected: aauthService.regModel2.corpType == 0 }">
              <input type="radio" name="corpType" id="corporateType" value="0" #corporateType (change)="radioChangeHandler($event)" formControlName="corpType" class="form-control"/>
              <label for="corporateType" id="lbRegisterCompany">a Company</label>
              <p>
                You have a company name by which you and your work are known.
              </p>
            </div>
          </div>
        </div>
        <div class="field form-group" [hidden]="isClaim">
          <input type="email" id="register-email" placeholder="Email Address" name="Email" class="form-control valid inputvalid" formControlName="email"/>
          <label for="register-email invalid">Email Address</label>
          <!-- valid <span *ngIf="Email.invalid && (Email.dirty || Email.touched)" class="alert alert-danger">Email is required.</span> -->
        </div>
        <div class="row">
          <div class="field half form-group">
            <select placeholder="Title" class="form-control" formControlName="title">
              <option *ngFor="let mItem of dbTitles" value="{{ mItem }}">
                {{ mItem }}
              </option>
            </select>
            <label>Title</label>
          </div>
          <div class="field half form-group">
            <input type="text" id="register-suffix" placeholder="Suffix" class="form-control" formControlName="suffice"/>
            <label for="register-suffix">Suffix</label>
          </div>
        </div>
        <div class="row">
          <div class="field half form-group">
            <input type="text" id="register-first-names" placeholder="First Name(s) *" class="form-control inputvalid" formControlName="firstName"/>
            <label for="register-first-names">First Name(s) *</label>
          </div>
          <div class="field half form-group">
            <input type="text" id="register-last-name" placeholder="Last Name *" class="form-control inputvalid" formControlName="lastName"/>
            <label for="register-last-name">Last Name *</label>
          </div>
        </div>
        <div class="field form-group">
          <select (change)="onCountryChange($event)" class="form-control inputvalid" formControlName="country">
            <option value="" selected="" disabled="">Choose Country</option>
            <option *ngFor="let mItem of dbCountries" [value]="mItem.countryCode">
              {{ mItem.countryName }}
            </option>
          </select>
          <label>Country *</label>
        </div>
        <div class="field form-group">
          <input type="number" id="register-zip" placeholder="Postal Code *" #postalCode class="form-control inputvalid" formControlName="postalCode" (blur)="onPostalCodeChange($event)"/>
          <label for="register-zip">Postal Code *</label>
        </div>
        <div class="row">
          <div class="field half form-group">
            <input type="text" id="register-address" placeholder="Street Address *" class="form-control inputvalid" formControlName="address"/>
            <label for="register-street-address">Street Address *</label>
          </div>
          <div class="field half form-group">
            <input type="text" id="register-city" placeholder="City *" class="form-control inputvalid" formControlName="city"/>
            <label for="register-city">City *</label>
          </div>
        </div>
        <div class="row">
          <div class="field half form-group">
            <select class="form-control inputvalid" formControlName="state">
              <option value="" selected="" disabled="">
                Choose State
              </option>
              <option *ngFor="let mItem of dbStates" [value]="mItem.stateCode">
                {{ mItem.stateName }}
              </option>
            </select>
            <label>State *</label>
          </div>
          <div class="field half form-group">
            <input type="tel" name="phone" id="register-cell" placeholder="Mobile Number" class="form-control" formControlName="phoneNumber"/>
            <label for="register-cell">Mobile Number</label>
          </div>
        </div>
        <!-- <div class="row">
          <div class="field half form-group">
            <input type="text" id="register-dob" placeholder="Date of birth *" class="form-control inputvalid" formControlName="dob"/>
            <label for="regster-dob">Date of birth *</label>
          </div>
          <div class="field half form-group">
            (Used for verification and account recovery)
          </div>
        </div> -->
        <div class="password">
          <h3>
            Create your password
            <em>
              (must contain at least 1 uppercase character, 1 lowercase character and 1 number)
            </em>
          </h3>
          <div class="row" formGroupName="passwords">
            <div class="field half form-group">
              <input type="password" id="register-pw" placeholder="Password *" data-lpignore="true" class="form-control inputvalid" formControlName="password" ng-minlength="6"/>
              <label for="register-pw">Password *</label>
              <span class="pass-view"></span>
            </div>
            <div class="field half form-group">
              <input type="password" id="register-confirm-pw" placeholder="Confirm Password *" data-lpignore="true" class="form-control inputvalid" formControlName="confirmPassword" ng-minlength="6"/>
              <label for="register-confirm-pw">Confirm Password *</label>
              <span class="pass-view"></span>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="!passwordValid() || !confirmPasswordValid()">
          <div class="form-group error-container" *ngIf="!passwordValid()">
            <small class="error">Password must be at least 6 characters, contain a capital, a number and a special character (-_+$).</small>
          </div>
          <div class="form-group error-container" *ngIf="!confirmPasswordValid()">
            <small class="error">The passwords do not match.</small>
          </div>
        </div>
        <!-- TODO: REPLACE with ng-bootstrap/twitter typeahead or something similar - that will not be a hack and we'll use in the future -->
        <div class="row">
          <div class="field form-group referrer">
            <ng-select2 id="referrer" width="100%" minimumInputLength="3" allowClear="true" [options]="select2Options" [data]="dbReferrers" class="form-control referrer" formControlName="referrer"></ng-select2>
            <label for="referrer">I was referred to Rankipedia by</label>
          </div>
        </div>
        <div class="form-group">
          <input type="checkbox" id="agree-t-c" class="form-control valid field" [ngClass]="{ 'is-invalid': f.agree.errors }" formControlName="agree" (change)="onCheckboxAgree($event)"/>
          <label for="agree-t-c" class="text-danger">By checking this box, I agree to Rankipedia
            <a href="/TermsOfUse" target="_blank">Terms of Use</a> and
            <a href="/PrivacyPolicy" target="_blank">Privacy Policy</a></label>
          <span *ngIf="AgreeCtrl.invalid && AgreeCtrl.touched" class="alert alert-danger">
            <span style="color: red; padding-top: 0.2rem;" *ngIf="AgreeCtrl.errors.required">Agree is required.</span>
          </span>
        </div>
        <div class="form-group">
          <br />
          <re-captcha formControlName="recaptcha" (resolved)="reCaptchaResolved($event)"></re-captcha>
        </div>
        <div class="form-group">
          <!-- class="form-control" -->
          <button class="btn primary" type="submit" [disabled]="aauthService.formModel2.invalid && !aauthService.isLocalHost()">
            Continue your registration
          </button>
        </div>
      </form>
    </div>
  </div>
</main>
